import { projectCameraAngleSelector } from '../../redux/slicers/camera/projectCameraAngleSlicer';
import { getAppState } from '../../redux/store';

const hasName = (name) => typeof name === 'string' && name.trim() !== '';

const isNameUnique = (name, id, cameras) => {
  if (!name) {
    name = ''
  }
  const cameraList = cameras || projectCameraAngleSelector(getAppState()).getProjectCameraAnglesList;
  const exist = cameraList
    .filter((c) => c.id !== id)
    .find((c) => c.cameraName.trim().toLowerCase() === name.trim().toLowerCase());
  return !exist;
};

export const isCameraNameValid = (name, id, { returnType = 'boolean', cameras } = {}) => {
  const empty = !hasName(name);
  const unique = isNameUnique(name, id, cameras);
  const valid = !empty && unique;

  if (returnType === 'boolean') {
    return valid;
  }

  return  {
    empty,
    unique,
    valid,
  }
};